/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PauseContractRouteImport } from './routes/pause-contract'
import { Route as HistoryRouteImport } from './routes/history'
import { Route as IndexRouteImport } from './routes/index'

const PauseContractRoute = PauseContractRouteImport.update({
  id: '/pause-contract',
  path: '/pause-contract',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryRoute = HistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/history': typeof HistoryRoute
  '/pause-contract': typeof PauseContractRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/history': typeof HistoryRoute
  '/pause-contract': typeof PauseContractRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/history': typeof HistoryRoute
  '/pause-contract': typeof PauseContractRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/history' | '/pause-contract'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/history' | '/pause-contract'
  id: '__root__' | '/' | '/history' | '/pause-contract'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  HistoryRoute: typeof HistoryRoute
  PauseContractRoute: typeof PauseContractRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/pause-contract': {
      id: '/pause-contract'
      path: '/pause-contract'
      fullPath: '/pause-contract'
      preLoaderRoute: typeof PauseContractRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history': {
      id: '/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof HistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  HistoryRoute: HistoryRoute,
  PauseContractRoute: PauseContractRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
